import { defineMessages } from 'react-intl'

export default defineMessages({
  defaultPlaceholder: {
    defaultMessage: 'Search...',
    description: 'table search bar | default placeholder',
  },
})
